const getDecorationTypeLv1List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('1');
    });
    let orderedList = filteredList.sort((a, b) => a.order - b.order)
    return orderedList;
}

const getDecorationTypeLv2List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('2');
    });
    return filteredList;
}

const getDecorationTypeLv3List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('3');
    });
    return filteredList;
}

const getDecorationTypeLv4List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('4');
    });
    return filteredList;
}

const getDecorationTypeLv5List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('5');
    });
    return filteredList;
}

const getDecorationTypeLv6List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('6');
    });
    return filteredList;
}

const getDecorationPortraitByTypeLv1 = (decorationPortraits, typeLv1Id) => {
    let filteredList = decorationPortraits.filter(item => {
        return item.typeLv1Id.toString() === typeLv1Id.toString()
    });
    return filteredList;
}

export {
    getDecorationTypeLv1List,
    getDecorationTypeLv2List,
    getDecorationTypeLv3List,
    getDecorationTypeLv4List,
    getDecorationTypeLv5List,
    getDecorationTypeLv6List,
    getDecorationPortraitByTypeLv1
}